import { render, staticRenderFns } from "./NavigatorUiItem.vue?vue&type=template&id=0366bc6c&lang=pug&"
import script from "./NavigatorUiItem.vue?vue&type=script&lang=js&"
export * from "./NavigatorUiItem.vue?vue&type=script&lang=js&"
import style0 from "./NavigatorUiItem.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0366bc6c')) {
      api.createRecord('0366bc6c', component.options)
    } else {
      api.reload('0366bc6c', component.options)
    }
    module.hot.accept("./NavigatorUiItem.vue?vue&type=template&id=0366bc6c&lang=pug&", function () {
      api.rerender('0366bc6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/NavigatorUiItem.vue"
export default component.exports